import React from 'react';
import { DraggableModal } from '@ui/shared/components/Common/DraggableModal';
import useAppStore from '../../stores/app';
import RoomSettings from './index';

/**
 * SettingsModal Component
 * 
 * Draggable modal wrapper for the RoomSettings component.
 * Opens when user clicks Settings in the navigation bar.
 */
export const SettingsModal = () => {
    const isOpen = useAppStore((state) => state.isSettingsModalOpen);
    const setSettingsModalOpen = useAppStore((state) => state.setSettingsModalOpen);

    const handleClose = () => {
        setSettingsModalOpen(false);
    };

    return (
        <DraggableModal
            isOpen={isOpen}
            onClose={handleClose}
            title="Settings"
            initialPosition={{ x: 100, y: 100 }}
            initialSize={{ width: 600, height: 500 }}
            minSize={{ width: 400, height: 300 }}
            maxSize={{ width: 900, height: 800 }}
            resizable={true}
            minimizable={true}
            id="vtc-settings-modal"
        >
            <RoomSettings isModal={true} />
        </DraggableModal>
    );
};

export default SettingsModal;
